module.exports = __webpack_public_path__ + "static/media/Anita.a9051b6a.jpg";